/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Master6Inputs */

const en_job_form_enum_master6 = /** @type {(inputs: Job_Form_Enum_Master6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master`)
};

const de_job_form_enum_master6 = /** @type {(inputs: Job_Form_Enum_Master6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master`)
};

/**
* | output |
* | --- |
* | "Master" |
*
* @param {Job_Form_Enum_Master6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_master6 = /** @type {((inputs?: Job_Form_Enum_Master6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Master6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_master6(inputs)
	return en_job_form_enum_master6(inputs)
});
export { job_form_enum_master6 as "job_form_enum_MASTER" }